export const SET_PROFILES = 'SET_PROFILES';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_SELECTED_INDEX = 'SET_SELECTED_INDEX';
export const SET_IS_PROFILE_SELECTED = 'SET_IS_PROFILE_SELECTED';
export const SET_PROFILESETTINGS = 'SET_PROFILESETTINGS'